module.exports = __webpack_public_path__ + "img/energyTotal.a11d7d5b.svg";